export default __webpack_public_path__ + "static/071-df5c1f00ab254b77d47047e0588452cd.jpg";